import { useConfig } from "../state";
import { HitLink } from "./HitLink";

export const TileHit = ({ hit }) => {
  const config = useConfig();
  return (
    <HitLink hit={hit}>
      <div className="w-32 lg:w-52">
        <img
          src={`${config.referenceUrl}/api/image/cadastre?c=${hit.geometry}&width=170&height=170`}
          srcSet={`${config.referenceUrl}/api/image/cadastre?c=${hit.geometry}&width=170&height=170 1x, ${config.referenceUrl}/api/image/cadastre?c=${hit.geometry}&width=340&height=340 2x`}
          className="w-full border-2 border-solid border-gray-300 rounded-lg"
          alt={hit.name}
        />
        <p>
          <i>{hit.addresses?.[0] || hit.name}</i> : {hit.area} m² – {hit.zone_2}
        </p>
      </div>
    </HitLink>
  );
};
